import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CategoryTopList from "./category-top-lists";
import { TreeNodeModel } from "../../models/category-new/category-tree-node";

const CategoryTopView = ({
  categoriesData,
  topCategorySelect,
  data,
  onSearch,
}: any) => {
  const { t } = useTranslation();
  const [categories, setCategories] = useState<TreeNodeModel[]>([]);

  useEffect(() => {
    setCategories(categoriesData);
  }, [categoriesData]);

  return (
    <>
      <div className="p-fluid formgrid top-header">
        <div className="grid">
          {/* <div className="col-12 md:col-6 lg:col-4 sm:col-12"> */}
            {/* <div className="flex align-items-center gap-3 flex-wrap"> */}
              {/* <h5 className="page-title m-0">{t("products_header")}</h5> */}
            {/* </div> */}
          {/* </div> */}

          {/* Search moved to AppTopbar - hiding this section */}
        </div>
      </div>

      <div className="pt-4 hide-sm">
        <div className="flex flex-wrap">
          <div className="flex-auto">
            {categories.length > 0 && (
              <CategoryTopList
                categoriesLists={categories}
                topCategorySelect={topCategorySelect}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryTopView;
